import { Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { DateformatService } from '@app/trackvision/util/dateformat.service';
import { NgbActiveModal, NgbDateParserFormatter, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { CostService } from '@services/cost.service';
import { RequirementService } from '@services/requirement.service';
import moment from 'moment';
import { Subject } from 'rxjs';
import { debounceTime } from 'rxjs/operators';
import { TypeEntity } from '../../enums/type-entity-enum';
import { CurrencyPipe } from '@app/pipes/currency.pipe';
import { ActivitiesValidator } from "@flows/shared/pop-up/activity-alert/validation/activities.validator";
import { ConfirmActionModalComponent } from '../../components/confirm-action-modal/confirm-action-modal.component';
import { AttachmentsService } from '@services/attachments.service';

@Component({
    selector: 'app-modal-form-fee',
    templateUrl: './modal-form-fee.component.html',
    styleUrls: ['./modal-form-fee.component.scss'],
    providers: [
        { provide: NgbDateParserFormatter, useClass: DateformatService },
        CurrencyPipe
    ],
    standalone: false
})
export class ModalFormFeeComponent implements OnInit {

  @ViewChild('inputFile', { static: false }) inputFile: ElementRef<HTMLInputElement>;
  @Input() titleModal: string;
  @Input() requirementId: number;
  @Input() isEdit: boolean;
  @Input() IdFee: number;
  @Output() insertCost = new EventEmitter<boolean>();
  @Input() costArray: any;


  feeForm: FormGroup;
  validation = {
    type: ''
  }

  listCurrency = [
    { id: "CLP", name: "CLP" },
    { id: "UF", name: "UF" },
    { id: "USD", name: "USD" }
  ]

  listType = [
    { id: "forhh", name: "Por hh" },
    { id: "only", name: "Único" },
    { id: "monthlyfee", name: "Fee Mensual" },
    { id: "propotional", name: "Proporcional" },
    { id: "monthly", name: "Mensual" },
  ]

  listStatus = [
    { id: "Por Pagar", name: "Por Pagar" },
    { id: "Pagado", name: "Pagado" },
    { id: "Anticipo", name: "Anticipo" }
  ]

  submitted: boolean = false;
  loading: boolean = false;

  private _successActivity = new Subject<string>();
  private _errorActivity = new Subject<string>();
  successMessageActivity: string = '';
  errorMessageActivity: string = '';

  collaborators: Array<any>;
  
  activities_validation_messages = ActivitiesValidator.ACTIVITIES_VALIDATION_MESSAGES;

  temporaryfiles = [];

  constructor(public activeModal: NgbActiveModal,
    private formBuilder: FormBuilder,
    private costService: CostService,
    public _requirements: RequirementService,
    private currencyPipe: CurrencyPipe,
    private _attachments: AttachmentsService,
    private modalService: NgbModal) {
    this.feeForm = this.formBuilder.group({
      id: [{ value: this.IdFee }],
      name: [null, [Validators.required]],
      amount: [null, [Validators.required, Validators.pattern('[0-9,.]+$')]],
      currency: ['CLP', [Validators.required]],
      type: [null, [Validators.required]],
      status: [null, [Validators.required]],
      collaboratorId: null,
      expirationDate: [null, [Validators.required]]
    });
  }

  ngOnInit() {

    this.getCollaborator();
    if (this.costArray) {
      this.getDataToEdit();
    }
  }

  /**
   * region Agregar Costo
   * @returns 
   */
  add() {

    this.loading = true;
    if (this.feeForm.invalid) {
      return;
    }
    this.submitted = true;

    if (this.isEdit) {
      this.edit();
    }
    else if (this.IdFee == null) {
      this.create();
    }
  }

  /**
   * region Crear Costo
   * @returns 
   */
  async create() {

    let cost = this.feeForm.value;
    const expirationDate = cost.expirationDate;    

    // delete the key id of cost
    delete cost.id;
    delete cost.expirationDate;
    Object.assign(cost, { typeEntity: TypeEntity.fee })
    Object.assign(cost,{expirationDate: moment(moment().year(expirationDate.year).month(expirationDate.month - 1).date(expirationDate.day)).format('YYYY-MM-DD')});
    if (this.temporaryfiles.length > 0) {
      const formData: FormData = new FormData();
      for (const [key, value] of this.temporaryfiles.entries()) {
        formData.append(`files[${key}]`, value, value.name);
      }
      formData.append("length", JSON.stringify(this.temporaryfiles.length));
      await this._attachments.uploadMultipleTemp(formData).toPromise()
        .then((resp) => {
          const filesArray = resp["result"];
          Object.assign(cost, { temporaryfilesids: filesArray });
          this.createCostByRequirementId(cost);
        });
    } else {
      this.createCostByRequirementId(cost);
    }

  }

    /**
   * Create cost
   * @param cost 
   * @param filesArray 
   */
    async createCostByRequirementId(cost: any) {
      await this.costService.createCostByRequirementId(this.requirementId, cost).subscribe({
        next: (data) => {
          this._successActivity.next('Se registró una actividad correctamente.');
          setTimeout(() => this.activeModal.dismiss(), 2000);
          setTimeout(() => this.insertCost.emit(true), 2000);
        },
        error: (e) => {
          this._errorActivity.next('Error al crear la actividad.');
          console.error(e)
        },
      });
    }


  /**
   * region Editar Costo
   */
  async edit() {
    let cost = this.feeForm.value;
    const expirationDate = cost.expirationDate; 
    delete cost.expirationDate;
    Object.assign(cost, { typeEntity: TypeEntity.fee })
    Object.assign(cost,{expirationDate: moment(moment().year(expirationDate.year).month(expirationDate.month - 1).date(expirationDate.day)).format('YYYY-MM-DD')});
    if(cost.amount.includes(',')){
      cost.amount = this.currencyPipe.parse(cost.amount);
    }
    if (this.temporaryfiles.length > 0) {
      const formData: FormData = new FormData();
      for (const [key, value] of this.temporaryfiles.entries()) {
        formData.append(`files[${key}]`, value, value.name);
      }
      formData.append("length", JSON.stringify(this.temporaryfiles.length));
      await this._attachments.uploadMultipleTemp(formData).toPromise()
        .then((resp) => {
          const filesArray = resp["result"];
          Object.assign(cost, { temporaryfilesids: filesArray });
          this.updateCost(cost);
        });
    } else {
      this.updateCost(cost);
    }
  }


    /**
 * Create cost
 * @param cost 
 * @param filesArray 
 */
    async updateCost(cost: any) {
      this.costService.updateCost(cost).subscribe({
        next: (data) => {
          this._successActivity.next('Se registró una actividad correctamente.');
          setTimeout(() => this.activeModal.dismiss(), 2000);
          setTimeout(() => this.insertCost.emit(true), 2000);
        },
        error: (e) => {
          this._errorActivity.next('Error al crear la actividad.');
          console.error(e)
        },
        //complete: () => console.info('complete')
      });
    }



  /**
   * region Mensajes de Error
   */
  messageActivity() {
    // messages
    this._successActivity.subscribe(message => this.successMessageActivity = message);
    this._successActivity.pipe(debounceTime(2500)).subscribe(() => this.successMessageActivity = '');

    this._errorActivity.subscribe(message => this.errorMessageActivity = message);
    this._errorActivity.pipe(debounceTime(2500)).subscribe(() => this.errorMessageActivity = '');

  }



  /**
   * region Asignar Datos desde Editar
   */
  getDataToEdit() {
    this.feeForm.reset({
      id: this.costArray.id,
      name: this.costArray.name,
      amount: this.costArray.amount,
      provider: this.costArray.provider,
      currency: this.costArray.currency,
      type: this.costArray.type,
      status: this.costArray.status,
      collaboratorId: this.costArray.collaboratorId,
      expirationDate: this.getDateNgbDatePicker(this.costArray.expirationDate) 
    })
  }


  getCollaborator() {
    this._requirements.getAllCollaboratorsData().subscribe(
      data => {
        this.collaborators = data['result'];
      },
      error => {
        this._errorActivity.next('Error al cargar los colaboradores.');
      }
    );
  }


  getDateNgbDatePicker(date: any) {
    if (date == null || date === '') {
      return null;
    }
    const s = String(date).trim();
    const dateOnly = s.includes('T') ? s.split('T')[0] : s.slice(0, 10);
    const d = dateOnly.split('-');
    const year = parseInt(d[0], 10);
    const month = parseInt(d[1], 10);
    const day = parseInt(d[2], 10);
    if (Number.isNaN(year) || Number.isNaN(month) || Number.isNaN(day)) {
      return null;
    }
    return { year, month, day };
  }


   /**
   * Click on input file
   */
   preFileUpload() {
    this.inputFile.nativeElement.click();
  }

  /**
   * Prepare the file that will be linked to the cost
   * @param file 
   */
  fileUploadChange(event) {
    this.temporaryfiles.push(event.target['files'][0])
  }

  /**
   * Delete file
   * @param costId 
   */
  deleteFile(costId?: number) {
    this.temporaryfiles = [];
    this.inputFile.nativeElement.value = null;
    if (costId) {
      this.openModalToDeleteFile(costId);
    }

  }

  //#region Abrir Modal para eliminar Costo
  openModalToDeleteFile(costId: number) {
    const confirmModal = this.modalService.open(ConfirmActionModalComponent, { size: 'sm', centered: true });
    confirmModal.componentInstance.message = `¿Deseas eliminar el documento vinculado al honorario?`;
    confirmModal.result.then(async (confirmed) => {
      if (confirmed) {
        const resp = await this.costService.deleteFile({ id: costId });
        if (resp.hasOwnProperty('result')) {
          this._successActivity.next('El documento fue eliminado con éxito.');
          this.costArray.url = null;
        } else {
          this._errorActivity.next('Error al eliminar el documento.');
        }
      }
    }).catch();
    return;
  }

}
